import { computeActorPose, type MovementPlan } from './movementPlan'
import { aircraftActorId } from './buildMovementPlan'
import type { EventPlacement } from '../engine/types'

/**
 * Live `[x, y, z]` scene-feet position of a placed aircraft at sim time `t`.
 *
 * With animation ON, reads the plane's pose from its motion plan so the value
 * tracks the aircraft as it taxis (matches what `useEventActorMotion` renders).
 * With animation OFF, returns the static parked position — exactly where
 * `useEventSceneSync` parks the model. Shared by click-picking, the selection
 * camera, and the anchored popover so all three agree on where the plane is.
 */
export function placementScenePosition(
  p: EventPlacement,
  plans: Record<string, MovementPlan>,
  t: number,
  animate: boolean
): [number, number, number] {
  if (animate) {
    const plan = plans[p.eventAllocationId]
    if (plan) {
      const pose = computeActorPose(plan, aircraftActorId(p.eventAllocationId), t)
      if (pose) return pose.position
    }
  }
  return [p.position[0], 0, p.position[1]]
}
